import React from "react"
import {Deal} from "@irati/types"
import {H3} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {isDealUnavailable} from "@irati/deals/helpers/deals/isDealUnavailable"
import withPerkOrReward, {WithPerkOrReward} from "@irati-web/flexi-rewards/src/utils/withPerkOrReward"

import {OnDealSubmit} from "../../containers/DealInfo"
import DealImportantInfoSavings from "./Savings"
import ImportantInfo from "./ImportantInfo"
import TermsAndConditions from "./TermsAndConditions"
import UnavailableDeal from "./UnavailableDeal"
import WebsiteUrl from "./WebsiteUrl"
import CTA from "./CTA"
import ExternalURLCTA from "./CTA/ExternalURLCTA"

interface Props extends WithPerkOrReward {
  id?: string
  deal: Deal
  onSubmit: OnDealSubmit
  allowEarnPointsModal?: boolean
}

const DealImportantInfo: React.FC<Props> = ({id, deal, onSubmit, allowEarnPointsModal, isRewards, isWallet}) => {
  const hideContinueButton = isRewards && isWallet
  return (
    <>
      <Flex justifyContent="space-between">
        <H3>
          <FormattedMessage id="perks.components.importantInfoBlock.importantInfoBlock.importantText" />
          <br />
          <FormattedMessage id="perks.components.importantInfoBlock.importantInfoBlock.infoText" />
        </H3>
        <DealImportantInfoSavings id={id} deal={deal} allowEarnPointsModal={allowEarnPointsModal} />
      </Flex>
      <ImportantInfo data={deal.importantInfo} />
      <WebsiteUrl id={id} deal={deal} />
      {isDealUnavailable(deal) && <UnavailableDeal />}
      <TermsAndConditions id={id} deal={deal} />
      {!isDealUnavailable(deal) && !hideContinueButton && <CTA id={id} deal={deal} onSubmit={onSubmit} />}
      {!isDealUnavailable(deal) && deal.externalLoginUrl && <ExternalURLCTA deal={deal} />}
    </>
  )
}

export default withPerkOrReward(DealImportantInfo)
